import React, { useState, useEffect } from 'react';

function DetailModal({ imdbID, apiKey, apiBase, onClose }) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(`${apiBase}?i=${imdbID}&plot=full&apikey=${apiKey}`);
        const data = await res.json();
        setDetails(data);
      } catch (err) {
        console.error('Failed to fetch details');
      } finally {
        setLoading(false);
      }
    };
    fetchDetails();
  }, [imdbID, apiKey, apiBase]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const hasPoster = details?.Poster && details.Poster !== 'N/A';

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-card">
        {loading && (
          <div className="modal-loading">
            <p>Loading details...</p>
          </div>
        )}
        {!loading && details && (
          <>
            {hasPoster ? (
              <img
                className="modal-poster"
                src={details.Poster}
                alt={details.Title}
              />
            ) : (
              <div className="modal-poster-placeholder">🎌</div>
            )}
            <div className="modal-body">
              <h2 className="modal-title">{details.Title}</h2>
              <div className="modal-badges">
                {details.Year && (
                  <span className="badge badge-year">{details.Year}</span>
                )}
                {details.Rated && details.Rated !== 'N/A' && (
                  <span className="badge">{details.Rated}</span>
                )}
                {details.Runtime && details.Runtime !== 'N/A' && (
                  <span className="badge badge-year">{details.Runtime}</span>
                )}
                {details.imdbRating && details.imdbRating !== 'N/A' && (
                  <span className="badge badge-rating">
                    ★ {details.imdbRating}/10
                  </span>
                )}
              </div>
              {details.Genre && details.Genre !== 'N/A' && (
                <div className="modal-badges">
                  {details.Genre.split(',').map((g) => (
                    <span key={g} className="badge">{g.trim()}</span>
                  ))}
                </div>
              )}
              {details.Director && details.Director !== 'N/A' && (
                <p className="modal-meta">
                  <strong>Director:</strong> {details.Director}
                </p>
              )}
              {details.Actors && details.Actors !== 'N/A' && (
                <p className="modal-meta">
                  <strong>Cast:</strong> {details.Actors}
                </p>
              )}
              {details.Plot && details.Plot !== 'N/A' && (
                <p className="modal-plot">{details.Plot}</p>
              )}
              <button className="modal-close" onClick={onClose}>
                Close
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DetailModal;